<form class="g-3" name="PasswordDetailForm" (ngSubmit)="Validate(PasswordDetailForm)" #PasswordDetailForm="ngForm"
    novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Password</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 px-1 pt-2">
                <label>New Password</label>
                <div class="input-group input-group">
                    <input type="password" class="form-control" placeholder="Ex. New Password" id="NewPassword"
                        [type]="showNewPassword ? 'text' : 'password'" name="NewPassword" [(ngModel)]="data.NewPassword"
                        #NewPassword="ngModel" required>

                    <div class="input-group-text bg-white" (click)="togglePasswordVisibility(1)"><i class="bi bi"
                            [ngClass]="{'bi-eye': !showNewPassword,'bi-eye-slash': showNewPassword}"></i>
                    </div>
                </div>
                <div class="invalid-feedback">
                    Please enter new password.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 px-1 pt-2">
                <label>Confirm Password</label>
                <div class="input-group input-group">
                    <input type="password" class="form-control" placeholder="Ex. Confirm Password" id="ConfirmPassword"
                        [type]="showConfirmPassword ? 'text' : 'password'" name="ConfirmPassword"
                        [(ngModel)]="data.ConfirmPassword" #ConfirmPassword="ngModel" required>
                    <div class="input-group-text bg-white" (click)="togglePasswordVisibility(2)"><i class="bi bi"
                            [ngClass]="{'bi-eye': !showConfirmPassword,'bi-eye-slash': showConfirmPassword}"></i>
                    </div>
                </div>

                <div class="invalid-feedback">
                    Please enter confirm password.
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-check"
                *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Change Password':'Loading...'}}</button>

        <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
                class="bi bi-x" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Close':'Loading...'}}</button>
    </div>
</form>